// extracted by mini-css-extract-plugin
export default {"dashboard":"style_dashboard__ZAoxr","sidebar":"style_sidebar__yLJox"};